import { render, staticRenderFns } from "./StylePageSettingWidget.vue?vue&type=template&id=27f8808a&scoped=true&"
import script from "./StylePageSettingWidget.vue?vue&type=script&lang=js&"
export * from "./StylePageSettingWidget.vue?vue&type=script&lang=js&"
import style0 from "./StylePageSettingWidget.vue?vue&type=style&index=0&id=27f8808a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27f8808a",
  null
  
)

export default component.exports